import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "tui-search-header"
};
var _hoisted_2 = {
  class: "tui-search-header-title"
};
var _hoisted_3 = {
  class: "tui-search-tabs"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  key: 1,
  class: "tui-search-time"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  key: 0,
  class: "tui-search-time-item-picker"
};
var _hoisted_8 = {
  key: 1
};
import { ref, computed, onMounted, onUnmounted } from '../../../adapter-vue';
import { TUITranslateService, TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { globalSearchTypeList, conversationSearchTypeList, searchMessageTypeDefault } from '../search-type-list';
import { searchMessageTimeList, searchMessageTimeDefault } from '../search-time-list';
import Icon from '../../common/Icon.vue';
import DatePicker from '../../common/DatePicker/index.vue';
import downArrowIcon from '../../../assets/icon/down-icon.svg';
import closeIcon from '../../../assets/icon/input-close.svg';
import closeDarkIcon from '../../../assets/icon/close-dark.svg';
import { isPC, isUniFrameWork } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    popupPosition: {
      type: String,
      default: 'bottom'
    },
    searchType: {
      type: String,
      default: 'global',
      validator(value) {
        return ['global', 'conversation'].includes(value);
      }
    }
  },
  emits: ['searchConfigChange', 'closeInConversationSearch'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var searchTypeList = computed(() => (props === null || props === void 0 ? void 0 : props.searchType) === 'conversation' ? conversationSearchTypeList : globalSearchTypeList);
    var currentSearchMessageType = ref(searchMessageTypeDefault[props === null || props === void 0 ? void 0 : props.searchType]);
    var currentSearchMessageTime = ref(searchMessageTimeDefault);
    var isTimeTabsShow = computed(() => {
      return currentSearchMessageType.value.key !== 'contact' && currentSearchMessageType.value.key !== 'group';
    });
    var datePickerRangeDisplayType = computed(() => isPC && props.searchType === 'global' && !isUniFrameWork ? 'two' : 'one');
    var isDatePickerShow = ref(false);
    function onCurrentSearchMessageTypeChange(typeObject) {
      if ((typeObject === null || typeObject === void 0 ? void 0 : typeObject.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
        currentSearchMessageType.value = (typeObject === null || typeObject === void 0 ? void 0 : typeObject.value) || searchMessageTypeDefault[props === null || props === void 0 ? void 0 : props.searchType];
      }
    }
    function onCurrentSearchMessageTimeChange(timeObject) {
      if ((timeObject === null || timeObject === void 0 ? void 0 : timeObject.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
        currentSearchMessageTime.value = (timeObject === null || timeObject === void 0 ? void 0 : timeObject.value) || searchMessageTimeDefault;
      }
    }
    onMounted(() => {
      TUIStore.watch(StoreName.SEARCH, {
        currentSearchMessageType: onCurrentSearchMessageTypeChange,
        currentSearchMessageTime: onCurrentSearchMessageTimeChange
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.SEARCH, {
        currentSearchMessageType: onCurrentSearchMessageTypeChange,
        currentSearchMessageTime: onCurrentSearchMessageTimeChange
      });
    });
    var selectSearchType = item => {
      TUIStore.update(StoreName.SEARCH, 'currentSearchMessageType', {
        value: item,
        searchType: props.searchType
      });
    };
    var selectSearchTime = item => {
      // 去除选日期情况触发 selectAllTime
      if (isDatePickerShow.value && item.key === 'all') {
        isDatePickerShow.value = false;
      } else {
        isDatePickerShow.value = false;
        TUIStore.update(StoreName.SEARCH, 'currentSearchMessageTime', {
          value: item,
          searchType: props.searchType
        });
      }
    };
    var handleSelectAllTimeClicked = () => {
      var _currentSearchMessage;
      if (((_currentSearchMessage = currentSearchMessageTime.value) === null || _currentSearchMessage === void 0 ? void 0 : _currentSearchMessage.key) !== 'all') {
        TUIStore.update(StoreName.SEARCH, 'currentSearchMessageTime', {
          value: searchMessageTimeDefault,
          searchType: props.searchType
        });
      } else {
        isDatePickerShow.value = true;
      }
    };
    var pickTimePeriod = time => {
      var _currentSearchMessage2;
      if (((_currentSearchMessage2 = currentSearchMessageTime.value) === null || _currentSearchMessage2 === void 0 ? void 0 : _currentSearchMessage2.key) === 'all') {
        var _endDate$toDate, _startDate$toDate;
        var {
          startDate,
          endDate
        } = time;
        var timePosition = Number(((endDate === null || endDate === void 0 || (_endDate$toDate = endDate.toDate()) === null || _endDate$toDate === void 0 ? void 0 : _endDate$toDate.getTime()) / 1000).toFixed(0));
        var timePeriod = timePosition - Number(((startDate === null || startDate === void 0 || (_startDate$toDate = startDate.toDate()) === null || _startDate$toDate === void 0 ? void 0 : _startDate$toDate.getTime()) / 1000).toFixed(0));
        var newSearchMessageTime = {
          key: currentSearchMessageTime.value.key,
          label: currentSearchMessageTime.value.label,
          value: {
            timePosition,
            timePeriod
          }
        };
        TUIStore.update(StoreName.SEARCH, 'currentSearchMessageTime', {
          value: newSearchMessageTime,
          searchType: props.searchType
        });
      }
    };
    var clearTimePicker = () => {
      var _currentSearchMessage3;
      isDatePickerShow.value = false;
      if (((_currentSearchMessage3 = currentSearchMessageTime.value) === null || _currentSearchMessage3 === void 0 ? void 0 : _currentSearchMessage3.key) === 'all') {
        TUIStore.update(StoreName.SEARCH, 'currentSearchMessageTime', {
          value: searchMessageTimeDefault,
          searchType: props.searchType
        });
      }
    };
    var closeSearchContainer = () => {
      emits('closeInConversationSearch');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['tui-search-container', !_unref(isPC) && 'tui-search-container-h5', _unref(isPC) && "container-".concat(props.popupPosition), "container-".concat(props.searchType)])
      }, [_createElementVNode("div", {
        class: _normalizeClass([_unref(isPC) && "tui-search-container-".concat(props.popupPosition), !_unref(isPC) && 'tui-search-container-h5-main'])
      }, [props.searchType === 'conversation' && !_unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(TUITranslateService).t("TUISearch.搜索会话内容")), 1), _createElementVNode("div", {
        class: "tui-search-header-close",
        onClick: closeSearchContainer
      }, [_createVNode(Icon, {
        file: _unref(closeDarkIcon),
        width: "14px",
        height: "14px"
      }, null, 8, ["file"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchTypeList), (tabItem, tabKey) => {
        return _openBlock(), _createElementBlock("div", {
          key: tabKey,
          class: _normalizeClass(['tui-search-tabs-item', _unref(currentSearchMessageType).key === tabItem.key && 'tui-search-tabs-item-selected']),
          onClick: $event => selectSearchType(tabItem)
        }, _toDisplayString(_unref(TUITranslateService).t("TUISearch.".concat(tabItem.label))), 11, _hoisted_4);
      }), 128))]), _renderSlot(_ctx.$slots, "input"), _unref(isTimeTabsShow) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchMessageTimeList), (tabItem, tabKey) => {
        return _openBlock(), _createElementBlock("div", {
          key: tabKey,
          class: _normalizeClass(['tui-search-time-item', _unref(currentSearchMessageTime).key === tabItem.key && 'tui-search-time-item-selected']),
          onClick: $event => selectSearchTime(tabItem)
        }, [tabItem.key === 'all' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [!_unref(isDatePickerShow) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tui-search-time-item-all",
          onClick: _withModifiers(handleSelectAllTimeClicked, ["stop"])
        }, [_createTextVNode(_toDisplayString(_unref(TUITranslateService).t("TUISearch.\u9009\u62E9\u65F6\u95F4") + ":  " + _unref(TUITranslateService).t("TUISearch.\u5168\u90E8")) + " ", 1), _createVNode(Icon, {
          file: _unref(downArrowIcon),
          width: "14px",
          height: "14px"
        }, null, 8, ["file"])])) : _createCommentVNode("", true), _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [_unref(isDatePickerShow) ? (_openBlock(), _createBlock(DatePicker, {
          key: 0,
          type: "range",
          rangeTableType: _unref(datePickerRangeDisplayType),
          onPick: pickTimePeriod
        }, null, 8, ["rangeTableType"])) : _createCommentVNode("", true)]), _unref(isDatePickerShow) ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "tui-search-time-item-close",
          onClick: clearTimePicker
        }, [_createVNode(Icon, {
          class: "icon",
          file: _unref(closeIcon),
          width: "14px",
          height: "14px"
        }, null, 8, ["file"])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(TUITranslateService).t("TUISearch.".concat(tabItem.label))), 1))], 10, _hoisted_6);
      }), 128))])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "result")], 2)], 2);
    };
  }
});